import React from 'react';
import { Link } from 'react-router-dom';

const CompanyContactUs: React.FC = () => {
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Contact Company</h6>
                        <p className="text-secondary small">Do let customer can communicate with you</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/company-profile"> Company</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Contact</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                {/* get support and join us */}
                <div className="py-4 py-lg-5 px-3 position-relative text-center rounded overflow-hidden mb-3 mb-lg-4 z-index-0 bg-theme-r-gradient">
                    <figure className="coverimg h-100 w-100 z-index-0 position-absolute top-0 start-0 m-0 opacity-25">
                        <img src={asset("assets/img/background-image/backgorund-image-2.jpg")} alt="" />
                    </figure>
                    <div className="row gx-3 justify-content-center z-index-1 position-relative">
                        <div className="col-12 col-md-8 col-lg-6">
                            <h2 className="mb-3">We are always here<br />We are Happy to Help you</h2>
                            <p className="opacity-75 small">To help and to guide you!<br />Contact us now, we will be back to you as soon as possible</p>
                        </div>
                    </div>
                </div>

                {/* contact us */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-8">
                        {/* other contacts*/}
                        <div className="row gx-3 gx-lg-4 justify-content-center">
                            <div className="col-12 col-md-12 col-xl-6 mb-4 mb-lg-5">
                                <h5>Head Office</h5>
                                <p className="text-secondary">
                                    3778 Golden Street<br />
                                    Miami, Florida, 33179,<br />
                                    United States
                                </p>
                                <p className="text-secondary mb-2"><i className="bi bi-telephone me-1"></i> +1 305-655-59S8</p>
                                <p className="text-secondary"><i className="bi bi-calendar-week me-1"></i> Mon-Fri 9:00 am - 7:00 pm</p>
                            </div>
                            <div className="col-12 col-md-12 col-xl-6 mb-4 mb-lg-5">
                                <h5>Sales</h5>
                                <p className="text-secondary">
                                    3778 Golden Street<br />
                                    Miami, Florida, 33179,<br />
                                    United States
                                </p>
                                <p className="text-secondary mb-2"><i className="bi bi-telephone me-1"></i> +1 305-655-59S8</p>
                                <p className="text-secondary"><i className="bi bi-calendar-week me-1"></i> Mon-Fri 9:00 am - 7:00 pm</p>
                            </div>
                        </div>

                        <hr />

                        {/* other contacts*/}
                        <div className="row gx-3 gx-lg-4 justify-content-center">
                            <div className="col-12 col-md-12 col-xl-6 mb-4 mb-lg-5">
                                <p className="h5">Technical problem</p>
                                <p className="text-secondary">If you have any type of technical challenges and would like to get help from us please drop an email at <a href="mailto:info@adminuiux.cos">tech@adminuiux.coms</a></p>
                            </div>
                            <div className="col-12 col-md-12 col-xl-6 mb-4 mb-lg-5">
                                <p className="h5">General Support</p>
                                <p className="text-secondary">If you have any type of challenges regarding products and would like to get help from us please drop an email at <a href="mailto:info@adminuiux.cos">sales@adminuiux.coms</a></p>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3">
                                    <div className="col-12 col-lg-12 mb-2">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="input-group input-group-lg"><span className="input-group-text text-theme-1"><i className="bi bi-person"></i></span>
                                                <div className="form-floating"><input placeholder="First Name" value="Max" required={true} className="form-control" /> <label>First Name</label></div>
                                                <div className="form-floating"><input placeholder="Last Name" value="Johnson" required={true} className="form-control" /> <label>last Name</label></div>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add valid data</div>
                                    </div>
                                    <div className="col-12 col-md-12 mb-2">
                                        <div className="form-group mb-3 position-relative">
                                            <div className="input-group input-group-lg"><span className="input-group-text text-theme-1"><i className="bi bi-envelope"></i></span>
                                                <div className="form-floating"><input type="email" placeholder="Email Address" required={true} className="form-control" /> <label>Email Address</label></div>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add valid data</div>
                                    </div>
                                    <div className="col-12 col-lg-12 mb-2">
                                        <div className="form-group mb-3 position-relative">
                                            <div className="input-group input-group-lg"><span className="input-group-text text-theme-1"><i className="bi bi-question-circle"></i></span>
                                                <div className="form-floating"><input placeholder="Subject" value="Johnson" required={true} className="form-control" /> <label>Subject</label></div>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add valid data</div>
                                    </div>
                                    <div className="col-12 col-md-12 mb-2">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="input-group input-group-lg"><span className="input-group-text text-theme-1"><i className="bi bi-chat-right-text"></i></span>
                                                <div className="form-floating"><textarea placeholder="Message" className="form-control h-auto" rows={2}></textarea> <label>Message</label></div>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add valid data</div>
                                    </div>
                                </div>
                                <div className="text-center d-grid">
                                    <button type="button" className="btn btn-theme">Submit Message</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* quick links */}
                <div className="row gx-3 gx-lg-4 justify-content-center">
                    <div className="col-12 col-md-4 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <i className="bi bi-chat-right-dots avatar avatar-60 text-theme-1 rounded h5 mb-3 fs-2"></i><br />
                                <h5 className="mb-1">Communicate</h5>
                                <p className="text-secondary mb-2">You have live assistant with whom you can share your query &amp; get answered.</p>
                                <a className="btn btn-link">Watch Community</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <i className="bi bi-life-preserver avatar avatar-60 text-theme-1 rounded h5 mb-3 fs-2"></i><br />
                                <h5 className="mb-1">Get Support</h5>
                                <p className="text-secondary mb-2">Connect with our expert by submitting details with photos &amp; documents.</p>
                                <a className="btn btn-link">Create Ticket</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <i className="bi bi-person-video3 avatar avatar-60 text-theme-1 rounded h5 mb-3 fs-2"></i><br />
                                <h5 className="mb-1">Schedule a Demo</h5>
                                <p className="text-secondary mb-2">Get details of features and quick look on how it works. Schedule a demo.</p>
                                <a className="btn btn-link">Book Demo</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default CompanyContactUs;
